import { BrowserRouter as Router } from "react-router-dom";
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import AppRoutes from "./app/AppRoutes";
import Login from "./app/pages/Login";
import { LoadingProvider, useLoading } from "./shared/state/LoadingContext";
import Layout from "./shared/layout/Layout";
import Loading from "./shared/ui/Loading";
import { useIsAuthenticated } from "@azure/msal-react";
import { useEffect, useState } from "react";
import {
  isUtilitiesSignedOut as readUtilitiesSignedOut,
  LOCAL_SIGNED_OUT_EVENT_NAME,
} from "./shared/auth/localSession";

const AppContent = () => {
  const { loading } = useLoading();
  const isAuthenticated = useIsAuthenticated();
  const [isUtilitiesSignedOut, setIsUtilitiesSignedOut] = useState(readUtilitiesSignedOut);

  useEffect(() => {
    const handleLocalSignOut = () => setIsUtilitiesSignedOut(true);
    window.addEventListener(LOCAL_SIGNED_OUT_EVENT_NAME, handleLocalSignOut);

    return () => window.removeEventListener(LOCAL_SIGNED_OUT_EVENT_NAME, handleLocalSignOut);
  }, []);

  if (isUtilitiesSignedOut) {
    return (
      <div className="App min-h-screen bg-gray-100">
        {loading && <Loading />}
        <Login />
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className="App min-h-screen bg-gray-100">
        {loading && <Loading />}
        <AppRoutes />
      </div>
    );
  }

  return (
    <div className="App min-h-screen bg-gray-100">
      <Layout>
        <main className="mx-auto w-full max-w-[1320px] min-w-0 p-4 flex-1 flex flex-col h-full overflow-y-auto scroll-pt-14 [scrollbar-gutter:stable_both-edges]">
          {loading && <Loading />}
          <AppRoutes />
        </main>
      </Layout>
    </div>
  );
};

function App() {
  return (
    <LoadingProvider>
      <Router>
        <AppContent />
      </Router>
    </LoadingProvider>
  );
}

export default App;
